import React, { useEffect, useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import PaginationControls from '../components/PaginationControls';

const PAGE_SIZE = 20;

function CourseList() {
  const [courses, setCourses] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const navigate = useNavigate();
  // Base API URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Fetch courses from the backend
  useEffect(() => {
    fetch(`${API_BASE_URL}/courses/get_courses.php?page=${page}`,{
      credentials: 'include'  // This ensures cookies (including session cookies) are sent
    })
      .then(response => response.json())
      .then(data => {
        setCourses(data.items || []);
        setTotalPages(data.total_pages || 1);
        setTotalRows(data.total_rows || 0);
      })
      .catch(error => console.error('Error fetching courses:', error));
  }, [page]);

  const handleEdit = (id) => {
    navigate(`/training-provider/configure-course/${id}`);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      icon: 'warning',
      text: 'Are you sure you want to delete this course?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });
    if (!result.isConfirmed) return;

    fetch(`${API_BASE_URL}/courses/delete_course.php?id=${id}`, {
      method: 'DELETE',
      credentials: 'include',
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setCourses(courses.filter(course => course.id !== id));
        } else {
          Swal.fire({ icon: 'error', text: 'Failed to delete course' });
        }
      })
      .catch(error => console.error('Error deleting course:', error));
  };

  return (
    <div>
      <h2>Available Courses</h2>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Code</th>
            <th>Title</th>
            <th>Description</th>
            <th>Duration (hours)</th>
            <th>Pre-requisite</th>
            <th>Status</th>
            <th>Remarks</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {courses.length > 0 ? (
            courses.map((course,index) => (
              <tr key={course.id}>
                <td>{(page - 1) * PAGE_SIZE + index + 1}</td>
                <td>{course.code}</td>
                <td>{course.title}</td>
                <td>{course.description}</td>
                <td>{course.duration}</td>
                <td>{course.pre_requisite}</td>
                <td>{course.status}</td>
                <td>{course.remarks}</td>
                <td>
                  <Button 
                    variant="warning" 
                    className="me-2" 
                    onClick={() => handleEdit(course.id)}
                  >
                    Edit
                  </Button>
                  <Button 
                    variant="danger" 
                    onClick={() => handleDelete(course.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">
                No courses available.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <PaginationControls page={page} totalPages={totalPages} totalRows={totalRows} onPageChange={setPage} />
      <Link to="/training-provider/configure-course">
          <Button variant="primary" className="m-1">Add New Course</Button>
        </Link>
        <Link to="/training-provider/upload-course">
        <Button variant="primary" className="m-1">Upload Courses</Button>
      </Link>
    </div>
          
  );
}

export default CourseList;
